import { render, staticRenderFns } from "./stop-sim-card-add-remark-modal.vue?vue&type=template&id=2c905c40"
import script from "./stop-sim-card-add-remark-modal.vue?vue&type=script&lang=js"
export * from "./stop-sim-card-add-remark-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports